import { EServiceBadRequestErrorCode } from 'types/response-code/service';

export const serviceErrorMessageInfo: Record<EServiceBadRequestErrorCode, string> = {
  '1': 'Service trùng path',
  '2': 'Không tìm thấy service',
  '-1': 'Vui lòng kiểm tra lại thông tin'
};
